const TYPES = {
    REDEEM: 'REDEEM',
    REDEEM_SUCCESS: 'REDEEM_SUCCESS',
    REDEEM_FAILED: 'REDEEM_FAILED',
    CLEAR_ERROR: 'CLEAR_ERROR'
};

export default {
    TYPES,

    redeem: (payload) => {
        return {
            type: TYPES.REDEEM,
            payload
        };
    },

    redeemSuccess: (resp) => {
        return ({
            type: TYPES.REDEEM_SUCCESS,
            payload: {resp}
        });
    },

    redeemFailed: (error) => {
        return {
            type: TYPES.REDEEM_FAILED,
            payload: {error}
        };
    },

    clearError: (resp) => {
        return ({
            type: TYPES.CLEAR_ERROR
        });
    }
};
